<template>
  <div class="toast-wrapper type-alert is-show bidding-toast">
    <div class="dialog-toast toast type-confirm">
      <div class="toast-wrap">
        <div class="dialog-content toast-cont is-show">
          <p class="dialog-tt toast-cont-ttl">title</p>
          <p class="dialog-txt toast-cont-txt">message</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    biddingData: {
      type: {},
      default: {},
    },
  },
  methods: {},
};
</script>
